import type { IconAction } from '../design-builder.types';

export const ICON_ACTION_OPTIONS: ReadonlyArray<{ value: IconAction; label: string }> = [
  { value: 'none', label: 'None (decorative)' },
  { value: 'info', label: 'Show information' },
  { value: 'reset', label: 'Reset filters and reload' },
  { value: 'refresh', label: 'Refresh data (keep filters)' },
  { value: 'filter', label: 'Open dashboard filters' },
  { value: 'search', label: 'Search filter options' },
  { value: 'download', label: 'Download dashboard data (JSON)' },
  { value: 'upload', label: 'Upload to a file upload control' },
  { value: 'share', label: 'Share published dashboard link' },
  { value: 'print', label: 'Print dashboard' },
];

export function normalizeIconAction(value: unknown): IconAction {
  return ICON_ACTION_OPTIONS.find((option) => option.value === value)?.value ?? 'none';
}

export function iconActionLabel(value: unknown): string {
  return ICON_ACTION_OPTIONS.find((option) => option.value === value)?.label ?? 'Icon';
}

/** Only newly inserted action glyphs get a default; old documents stay decorative. */
export function defaultIconAction(name: string): IconAction {
  const actions: Record<string, IconAction> = {
    Funnel: 'filter', ListFilter: 'filter', RefreshCw: 'refresh', RotateCcw: 'reset',
    Info: 'info', Search: 'search', Download: 'download', Upload: 'upload', Share2: 'share', Printer: 'print',
  };
  return actions[name] ?? 'none';
}
